module.exports = __webpack_public_path__ + "img/header-rebate.832edf39.svg";